import { render, staticRenderFns } from "./SupplyDetailForm.vue?vue&type=template&id=05136204"
import script from "./SupplyDetailForm.vue?vue&type=script&lang=js"
export * from "./SupplyDetailForm.vue?vue&type=script&lang=js"
import style0 from "./SupplyDetailForm.vue?vue&type=style&index=0&id=05136204&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports